import { Gift, ArrowRight } from "lucide-react";
import { applyPromoOffer } from "@/lib/promo";

export default function PromoBanner() {
  return (
    <div
      role="region"
      aria-label="Offre de lancement"
      data-testid="promo-banner"
      className="relative z-[60] w-full bg-gradient-to-r from-cyan-400 via-sky-400 to-blue-500 px-4 py-2"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center">
        <p className="flex items-center gap-2 text-[11px] font-semibold leading-tight text-night sm:text-xs">
          <Gift className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <span>Offre de lancement : 10 € offerts sur votre premier état des lieux !</span>
        </p>
        <button
          data-testid="promo-banner-cta"
          onClick={applyPromoOffer}
          className="inline-flex items-center gap-1.5 rounded-full bg-night/90 px-3.5 py-1 text-[11px] font-bold text-cyan-300 transition-colors duration-300 hover:bg-night"
        >
          Profiter de l'offre
          <ArrowRight className="h-3 w-3" aria-hidden />
        </button>
      </div>
    </div>
  );
}
